(function(){
    'use strict';

    var OptOutCtrl =  function ($http, $scope,  $window) {

        console.log("Inside OptOutCtrl");
        $scope.optOutReasonModel = {};
        $scope.selection = "";
        $scope.reasonText = "";
        $scope.radioChange = function () {

           debugger;
            $scope.reasonText = $scope.selection;

            console.log("Inside function");
        }

    }

    OptOutCtrl.$inject =  ['$http','$scope','$window'];
    angular.module('app').controller('OptOutCtrl' ,OptOutCtrl);


}());